import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Footer() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-navy-950 text-white pt-20 pb-10 border-t border-navy-900" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-57">
          <FadeIn data-id="element-58">
            <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8" data-id="element-59">
              ¿Listo para empezar tu carrera en el mar?
            </h2>
            <Button size="xl" onClick={scrollToPricing} className="w-full sm:w-auto" data-id="element-60">
              👉 Quiero acceder ahora sin riesgo
            </Button>
          </FadeIn>
        </div>

        <div className="border-t border-navy-800 pt-8 text-center text-gray-500 text-sm" data-id="element-61">
          <p data-id="element-62">
            © 2026 Convertite en Capitán Internacional. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}